import { useState } from 'react';
import styled, { css } from 'foundations-theming/utils';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { ExpandingTextArea } from 'foundations-components/transitional/components/ExpandingTextArea';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { StopIcon } from 'foundations-assets/icons/components/StopIcon';
import { TwoFAOutlineIcon } from 'foundations-assets/icons/components/TwoFAOutlineIcon';
import { BreezeButton } from 'ai-components-ui-library/components/buttons/BreezeButton';
import { BreezeSendIcon } from 'ai-components-ui-library/components/icons/internal/BreezeSendIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_LEADING_ICON = /*#__PURE__*/_jsx(TwoFAOutlineIcon, {
  color: "text-core-disabled",
  size: "500"
});
const StyledTextareaOverrides = styled.div.withConfig({
  displayName: "ChatTextInput__StyledTextareaOverrides"
})(["", " inline-size:100%;"], css(["textarea{max-block-size:44px !important;overflow-y:auto !important;}"]));
export const ChatTextInput = ({
  autoFocus,
  disabled = false,
  inputRef,
  leadingIcon = DEFAULT_LEADING_ICON,
  onChatInputChanged,
  onKeyDown,
  onSend,
  onStop,
  placeholder,
  value
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const sendDisabled = disabled || !value || value.trim().length === 0;
  return /*#__PURE__*/_jsx(StyledTextareaOverrides, {
    children: /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-surface-default",
      borderColor: isFocused ? 'border-secondary-default' : 'border-core-default',
      borderRadius: "300",
      borderStyle: "solid",
      borderWidth: "100",
      boxShadow: "100",
      inlineSize: "100%",
      paddingBlock: "400",
      paddingInline: "400",
      position: "relative",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "end",
        flexDirection: "row",
        inlineSize: "100%",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsxs(View, {
          inlineSize: "100%",
          paddingBlockEnd: "0",
          position: "relative",
          children: [leadingIcon && /*#__PURE__*/_jsx(Flex, {
            alignItems: "center",
            insetBlockStart: "100",
            insetInlineStart: "100",
            justifyContent: "center",
            position: "absolute",
            children: leadingIcon
          }), /*#__PURE__*/_jsx(ExpandingTextArea, {
            autoFocus: autoFocus,
            backgroundColor: "fill-surface-default",
            "data-test-id": "chat-input-element",
            disableFocusStyles: true,
            disabled: disabled,
            id: "chat-input-element",
            inputRef: inputRef,
            maxHeight: 44,
            minBlockSize: "22px",
            onBlur: () => setIsFocused(false),
            onChange: onChatInputChanged,
            onFocus: () => setIsFocused(true),
            onKeyDown: onKeyDown,
            padding: "0",
            paddingInlineStart: leadingIcon ? '700' : '0',
            placeholder: placeholder,
            resize: true,
            shrink: true,
            styled: false,
            value: value
          })]
        }), /*#__PURE__*/_jsx(View, {
          paddingInlineStart: "400",
          children: onStop ? /*#__PURE__*/_jsx(IconButton, {
            "aria-label": "Stop",
            "data-test-id": "chat-stop-button",
            onClick: onStop,
            shape: "circle",
            size: "xs",
            use: "transparent",
            children: /*#__PURE__*/_jsx(StopIcon, {})
          }) : /*#__PURE__*/_jsx(BreezeButton, {
            "data-test-id": "chat-send-button",
            disabled: sendDisabled,
            name: "send",
            onClick: onSend,
            shape: "circle",
            size: "xs",
            children: /*#__PURE__*/_jsx(BreezeSendIcon, {})
          })
        })]
      })
    })
  });
};